<template>
  <div>
    <el-button style="padding: 0; margin: 20px;" type="text" icon="el-icon-back" @click="$router.go(-1)">返回</el-button>
    <el-input class="search-el" size="mini" v-model="query.name" placeholder="请输入名称"></el-input>
    <el-button type="primary" size="mini" @click="getListQuery()">
      查询
    </el-button>
    <el-button type="primary" size="mini" @click="addRecommendGood">添加</el-button>
    <el-row>
      <el-table v-loading="loading" :data="list" border size="mini" :stripe="true" style="width: 100%; margin: 20px 0">
        <el-table-column label="ID" align="center" min-width="5%">
          <template slot-scope="{ row }">
            <div>{{ row.id }}</div>
            <div :class="{ 'childtag': row.isopen, 'activetag': true }" :style="{ height: row.isopen ? 'auto' : '0' }">
              <div style="height: 23px;" v-for="item in row.data" :key="item.id"></div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="推荐擅长方向" align="center" min-width="5%">
          <template slot-scope="{ row }">
            <div style=" font-size:14px">{{ row.title }}</div>
            <transition name="slide" class="dasdad">
              <div :class="{ 'childtag': row.isopen, 'activetag': true }"
                :style="{ height: row.isopen ? 'auto' : '0' }">
                <div style="height: 23px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;" v-for="item in row.data" :key="item.id">{{ item.title }}
                </div>
              </div>
            </transition>
          </template>
        </el-table-column>

        <el-table-column label="添加时间" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <div>{{ row.created_at }}</div>
            <div :class="{ 'childtag': row.isopen, 'activetag': true }" :style="{ height: row.isopen ? 'auto' : '0' }">
              <div style="height: 23px;" v-for="item in row.data" :key="item.id"></div>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="修改时间" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <div>{{ row.updated_at }}</div>
            <div :class="{ 'childtag': row.isopen, 'activetag': true }" :style="{ height: row.isopen ? 'auto' : '0' }">
              <div style="height: 23px;" v-for="item in row.data" :key="item.id"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="二级分类" align="center" min-width="5%">
          <template slot-scope="{ row }">

            <div>{{ row.item_num }}</div>

            <div :class="{ 'childtag': row.isopen, 'activetag': true }" :style="{ height: row.isopen ? 'auto' : '0' }">
              <div style="height: 23px; color: #66b1ff;" v-for="item in row.data" :key="item.id"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="排序" align="center" min-width="5%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="updateRecommendSort(row.id)">
              <div>{{ row.sort }}</div>
            </el-button>
            <div :class="{ 'childtag': row.isopen, 'activetag': true }" :style="{ height: row.isopen ? 'auto' : '0' }">
              <div style="height: 23px; color: #66b1ff;" v-for="item in row.data" :key="item.id"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="显示状态" align="center" min-width="5%">
          <template slot-scope="{ row }">
            <el-switch v-model="row.status" active-color="#13ce66" inactive-color="#ff4949" @change="updateStatus(row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="getTaglistHandel(row)" v-if="!row.isopen"
              style="font-size:14px">
              展开
            </el-button>
            <el-button type="text" size="small" @click="clossTaglistHandel(row)" v-if="row.isopen"
              style="font-size:14px">
              收回
            </el-button>
            <el-button type="text" size="small" @click="redactTagHandel(row)" style="font-size:14px">
              编辑
            </el-button>
            <el-button type="text" size="small" @click="deleteTag(row.id, 1)" style="color:red;font-size:14px">
              删除
            </el-button>
            <!-- <div :class="{ 'childtag': row.isopen, 'activetag': true }" :style="{ height: row.isopen ? 'auto' : '0' }">
              <div style="display: flex; justify-content: center;" v-for="item in row.data" :key="item.id">
                <div style="height: 23px; margin-right: 10px;color: #66b1ff; cursor: pointer;"
                  @click="redactTagHandel(item)">编辑</div>
                <div style="height: 23px;color: #66b1ff; cursor: pointer; color:red" @click="deleteTag(item.id)">删除
                </div>
              </div>
            </div> -->
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <el-dialog title="添加推荐擅长方向" :visible.sync="adept.chooseOrgVisible" width="40%" :before-close="adeptFormOnClose">
      <div class="dailogContent">
        <updateRecommendGood @getInfo="getInfo" ref="addRecommend"></updateRecommendGood>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">创 建</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改推荐擅长方向" :visible.sync="redactdialogVisible" width="40%" :before-close="redacthandleClose">
      <div class="dailogContent">
        <updateRecommendGood @getInfo="getInfo" :disabledid="disabledid" ref="updateInfo"></updateRecommendGood>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">创 建</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {
  updateRecommendSort,
  adeptSet,
  getRecommendTaglist,
  addTagstore,
  setRecommendStatus,
  edittag,
  destroyRecommend,
  updateRecommendInfo,
  matchRecommendchild,
} from "@/api/psyAdept";
import updateRecommendGood from "@/views/psy/psy_tree/updateRecommendGood";

export default {
  components: { updateRecommendGood },
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        name: "",
      },
      adept: {
        chooseOrgVisible: false,
        formLabelWidth: "120px",
        query: {
          title: "",
        },
      },
      redactdialogVisible: false,
      childredactdialogVisible: false,
      options: [],
      options2: [],
      options3: [],
      ruleForm: {
        name: "",
        value: "",
      },
      value: "",
      activeid: "",
      second: [], // 二级标签
      updateInfo:{},
      disabledid:'',
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    addRecommendGood(){
      this.adept.chooseOrgVisible = true; 
      this.toCreate()
      this.$nextTick(()=>{
        this.$refs.addRecommend.pageInfo()
      })
    },
    getTaglistHandel(row) {
      // 展开
      this.second = [];
      let params = {
        p_id: row.id,
      };
      row.isopen = true;
      matchRecommendchild(params).then((res) => {
        if (res.code) {
          this.second = res.data;
          let index = this.list.findIndex((obj) => obj.id === row.id);
          if (index !== -1) {
            let matchedObject = this.list[index];
            matchedObject.data = [];
            // 比较数组内容
            if (!this.arraysAreEqual(matchedObject.data, this.second)) {
              // 更新对象
              matchedObject.data = this.second.slice(); // 使用slice复制数组，确保不改变原始数组

              // 更新list数组
              this.list[index] = matchedObject;
            } else {
              return false
            }
          } else {
            return false
          }
        }
      });
    },
    arraysAreEqual(arr1, arr2) {
      if (arr1.length != arr2.length) {
        return false;
      }
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    },
    clossTaglistHandel(row) {
      // 收回
      row.isopen = false;
    },
    addtagHandel() {
      // 确定修改标签 edittagHandel
      if (this.ruleForm.name == "") {
        this.$message({
          message: "标签名称不能为空",
          type: "error",
        });
        return;
      } else {
        edittag({
          id: this.disabledid,
          p_id: null,
          title: this.ruleForm.name,
        }).then((res) => {
          if (res.code) {
            this.redactdialogVisible = false;
            this.options = [];
            this.ruleForm.name = "";
            this.getList();
          }
        });
      }
    },
    redactTagHandel(row) {
      this.redactdialogVisible = true;
      this.disabledid = row.id;
      this.ruleForm.name = row.title;
      this.$nextTick(()=>{
        this.$refs.updateInfo.pageInfo()
      })
      getRecommendTaglist({ title: "" }).then((res) => {
        if (res.code) {
          // this.options = res.data
          res.data.forEach((item) => {
            let label = item.title;
            let count = 1;
            while (
              this.options.some(
                (option) => option.label === label
              )
            ) {
              label = `${item.title} (${count})`; // 添加计数器以确保唯一性
              count++;
            }
            this.options.push({ label, value: item.id });
          });
          
        }
      });
    },
    
    redacthandleClose() {
      //
      this.redactdialogVisible = false;
      this.options = [];
      this.ruleForm.name = "";
    },
    childredactHandel() {
      this.childredactdialogVisible = false;
      this.options3 = [];
    },
    toCreate() {
      this.adept.query.title = "";
      getRecommendTaglist({ title: "" }).then((res) => {
        if (res.code) {
          res.data.forEach((item) => {
            let label = item.title;
            let count = 1;
            while (
              this.options2.some(
                (option) => option.label === label
              )
            ) {
              label = `${item.title} (${count})`; // 添加计数器以确保唯一性
              count++;
            }
            this.options2.push({ label, value: item.id });
          });
          
        }
      });
    },

    adeptSet(id, type) {
      const text = { 0: "下架", 1: "上架" };
      this.$confirm("是否确认【" + text[type] + "】？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        adeptSet({
          id: id,
          status: type,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "设置成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },

    addAdept() {
      if (this.adept.query.title == "") {
        this.$message({
          message: "请填写标签名称",
          type: "error",
        });
        return;
      } else {
        addTagstore({
          p_id: parseInt(this.adept.query.value) || 0,
          title: this.adept.query.title,
        }).then((response) => {
          if (response.status == 2000) {
            this.$message({
              showClose: true,
              message: "添加成功",
              type: "success",
            });
            this.adeptFormOnClose();
          } else {
            this.adeptFormOnClose();
          }
        });
      }
    },

    // 弹窗关闭
    adeptFormOnClose() {
      this.adept.chooseOrgVisible = false;
      this.adept.query.title = "";
      this.adept.query.value = "";
      this.adept.query.id = 0;
      this.options2 = [];
      
      this.getList();
    },

    getListQuery() {
      this.query.page = 1;
      this.getList();
    },

    getList() {
      this.loading = true;
      let query = {
        title: this.query.name,
      };
      getRecommendTaglist(query).then((response) => {
        this.list = response.data;
        this.list = this.list.map((item) => {
          return { ...item, isopen: false, data: [] };
        });
        
        this.loading = false;
      });
    },

    updateRecommendSort(id) {
      this.$prompt("请输入排序", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[0-9]/,
        inputValidator: function checkRefundNumber(num) {
          var reg = /[^\d\.]/g;
          if (num && new RegExp(reg).test(num)) {
            //非数字
            return "请输入数字";
          }
        },
        inputErrorMessage: "请输入数字",
      })
        .then(({ value }) => {
          updateRecommendSort({
            id: id,
            sort: value,
          }).then((response) => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => { });
    },

    timeEffectInput(value) {
      //value 为获取到的输入框的值
      if (value.length >= 400) {
        this.$el.querySelector(".el-input__count").style =
          "color:red !important";
      } else {
        this.$el.querySelector(".el-input__count").style =
          "color:#909399 !important";
      }
    },

    deleteTag(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        destroyRecommend({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.second = []; // 置空
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },
    getInfo(val){
      this.updateInfo = val
    },
    confirm(){
      let tagArr = this.getSelectedIds(this.updateInfo.tag);
      let option = {
        id: this.disabledid,
        arr_json:{
          title: this.updateInfo.title,
          status: this.updateInfo.status,
          tag:tagArr,
        }
      }
      updateRecommendInfo(option).then((res) => {
        if(res.code == 1){
          this.adept.chooseOrgVisible = false
          this.redactdialogVisible = false
          this.updateInfo = {}
          this.getList();
          this.disabledid = ''
        }
          
      })
    },
    cancel(){
      this.adept.chooseOrgVisible = false
      this.redactdialogVisible = false
      this.updateInfo = {}
    },
    getSelectedIds(data) {
      return data.reduce((acc, item) => {
        // 如果当前对象 selected 为 true，添加其 id 到结果数组
        if (item.selected) {
          acc.push(item.id);
        }

        // 如果存在嵌套的 list，递归处理
        if (item.list) {
          acc.push(...this.getSelectedIds(item.list));
        }

        return acc;
      }, []);
    },
    updateStatus(info){
      let option = {
        id: info.id,
        status: info.status
      }
      if(!info.status){
        this.$confirm('确认要隐藏该推荐擅长方向吗？', '隐藏提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          setRecommendStatus(option).then((res) => {

          })
        }).catch(()=>{
          info.status = true
        })
        return
      }
      this.$confirm('确认要显示该推荐擅长方向吗？', '显示提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        setRecommendStatus(option).then((res) => {

        })
      }).catch(() => {
        info.status = false
      })
      return
      
    }
  },
};
</script>
<style lang="scss" scoped>
  .dailogContent{
    height: 400px;
    overflow: auto;
  }
</style>
<style>
.redactinput {
  width: 217px;
}

.slide-enter-active,
.slide-leave-active {
  transition: height 5s;
}

.slide-enter,
.slide-leave-to {
  height: 0;
}
</style>